/** Shared spacing for Creator and Variations row action menus. */
export const ROW_ACTION_MENU_SURFACE =
  'flex min-w-[12rem] w-max max-w-[calc(100vw-2rem)] flex-col gap-[4px] rounded-lg border border-gray-200 bg-white p-[10px] shadow-lg';

export const ROW_ACTION_MENU_ITEM =
  'grid min-h-[32px] w-full grid-cols-[16px_minmax(0,1fr)] items-center gap-x-[8px] rounded-md px-[6px] py-[6px] text-left text-sm leading-[20px] transition-colors focus:outline-none focus-visible:bg-gray-100 disabled:opacity-50';

/** The divider starts where item icons start, with equal inset on both sides. */
export const ROW_ACTION_MENU_DIVIDER = 'mx-[6px] border-t border-gray-200 first:hidden';
